import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/Addresses/Handlers/UpdateSearchFields";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    shipTosDataView: getShipTosDataView(state, state.pages.addresses.getShipTosParameter),
});

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AddressBookPaginationStyles {
    pagination?: PaginationPresentationProps;
    container?: InjectableCss;
}

export const addressBookPaginationStyles: AddressBookPaginationStyles = {};

const styles = addressBookPaginationStyles;

const AddressBookPagination = ({ shipTosDataView, updateSearchFields, fields }: Props) => {
    const container = {
        css: css`
            > div:first-child {
                background: ${fields.backgroundColor} !important;
            }
        `,
    };
    if (!shipTosDataView.value || !shipTosDataView.pagination) {
        return null;
    }

    const { totalItemCount, page, pageSize, pageSizeOptions, prevPageUri, nextPageUri } = shipTosDataView.pagination;
    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        updateSearchFields({
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    return (
        <StyledWrapper {...container}>
            <Pagination
                {...styles.pagination}
                resultsCount={totalItemCount}
                currentPage={page}
                resultsPerPage={pageSize}
                resultsPerPageOptions={pageSizeOptions}
                onChangePage={changePage}
                onChangeResultsPerPage={changeResultsPerPage}
                prevPage={prevPageUri}
                nextPage={nextPageUri}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AddressBookPagination),
    definition: {
        group: "Addresses",
        icon: "house",
        allowedContexts: ["AddressesPage"],
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                editorTemplate: "TextField",
                defaultValue: "#linear-gradient(90deg,#266b40 27.08%,#2d804c 71.87%,#43687a 100%)",
                fieldType: "General",
                displayName: "Background Color",
            },
        ],
    },
};

export default widgetModule;
